
import { useState } from "react";
import { handleGameWinFinal, handleGameLoss } from "../managers/GameStatusManager";
import { handleGameProgression } from "../managers/GameProgressionManager";
import { getMaxAttemptsForLevel } from "../GameLogic";
import { GameStatus, GuessHistory, ValidatedGuess, KeyboardStatus, PreviousWord } from "@/lib/types/GameTypes";

export const useGameProgression = (
  currentWord: string,
  onCorrectGuess: () => void,
  onGameOver: () => void
) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const handleCorrectGuess = async (
    currentLevel: number,
    guesses: ValidatedGuess[],
    guessHistory: GuessHistory,
    levelAttempts: number[],
    gameStatus: GameStatus,
    keyboardStatus: KeyboardStatus,
    validatedGuess: ValidatedGuess,
    setGuesses: (guesses: ValidatedGuess[]) => void,
    setKeyboardStatus: (status: KeyboardStatus) => void,
    setCurrentGuess: (guess: string) => void,
    setGameStatus: (status: GameStatus) => void,
    setShowGameCompletion: (show: boolean) => void,
    setGuessHistory: (history: GuessHistory) => void,
    setLevelAttempts: (attempts: number[]) => void,
    setPreviousWord: (word: PreviousWord) => void
  ) => {
    console.log('🔄 GAME PROGRESSION - handleCorrectGuess START:', {
      currentLevel,
      currentWord,
      isTransitioning: isTransitioning,
      timestamp: new Date().toISOString()
    });

    const { newLevelAttempts, updatedGuessHistory } = await handleGameProgression(
      currentWord,
      currentLevel,
      guesses,
      guessHistory,
      levelAttempts,
      gameStatus,
      keyboardStatus,
      validatedGuess,
      onCorrectGuess,
      setIsTransitioning,
      setGuesses,
      setKeyboardStatus,
      setCurrentGuess,
      setGameStatus,
      setShowGameCompletion,
      setPreviousWord
    );
    
    console.log('🔄 GAME PROGRESSION - Updating state after progression:', {
      newLevelAttempts,
      updatedGuessHistoryLength: updatedGuessHistory.length,
      timestamp: new Date().toISOString()
    });
    
    setLevelAttempts(newLevelAttempts);
    setGuessHistory(updatedGuessHistory);
    
    console.log('🔄 GAME PROGRESSION - handleCorrectGuess COMPLETE', {
      timestamp: new Date().toISOString()
    });
  };

  const handleFailedAttempt = async (
    currentLevel: number,
    guesses: ValidatedGuess[],
    setGameStatus: (status: GameStatus) => void,
    setShowGameCompletion: (show: boolean) => void
  ) => {
    const maxAttempts = getMaxAttemptsForLevel(currentWord.length);
    
    if (guesses.length >= maxAttempts) {
      console.log('Game over - max attempts reached', {
        attempts: guesses.length,
        maxAttempts,
        wordLength: currentWord.length,
        timestamp: new Date().toISOString()
      });
      
      // Set game status to lost
      await handleGameLoss(setGameStatus, () => {}, currentLevel);
      
      // Call onGameOver immediately - we need this to trigger UI updates
      onGameOver();
    }
  };

  return {
    isTransitioning,
    setIsTransitioning,
    handleCorrectGuess,
    handleFailedAttempt
  };
};
